module.exports = {
  "tourInteraction": {
    "name": "tour interaction",
    "class": "interaction",
    "properties": {
      "appName": {
        "type": "string"
      },
      "tourId": {
        "type": "string"
      },
      "stepId": {
        "type": "string",
        "isOptional": true
      },
      "action": {
        "type": "string"
      },
      "value": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "ui-shepherd-react"
  },
  "tourProgress": {
    "name": "shepherd tour progress event",
    "class": "interaction",
    "properties": {
      "appName": {
        "type": "string"
      },
      "tourId": {
        "type": "string"
      },
      "stepId": {
        "type": "string",
        "isOptional": true
      },
      "action": {
        "type": [
          "tour start",
          "tour close",
          "tour finish",
          "tour view step"
        ]
      }
    },
    "namespace": "ui-shepherd-react"
  }
};